import React, { useState } from 'react'
import Header from '../../../layouts/doctor/DoctorHeader'
import { Managestafftable } from './Managestafftable';
import { useOutletContext } from 'react-router-dom';

import AddTeamModal from './AddTeamModal';


export const Managestaff = () => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [update, setUpdate] = useState(false);
    const [loading, setLoading] = useOutletContext();

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleSearchChange = (event) => {
      setSearch(event.target.value); 
    };
  
    
    return (
        <div>
            <Header pageTitle="Manage Team" />
            <div className="cardOuter">
                <div className="cardheads">
                    <div className="cardTitle">
                        Manage Team
                    </div>
                    <button className="btn blackoutlineBtn" onClick={handleClickOpen}>Add Team</button>
                </div>
                <div className="cardcontents">
                    <div className="tabpanelControl mt-3">
                        <div className="topsearchs">
                            <div className="searchBar">
                            <input 
                              type="text" 
                              autoComplete="off" 
                              placeholder="Search" 
                              value={search}
                              onChange={handleSearchChange} 
                            />
                            </div>

                        </div>
                        <div className="tableimgs">
                            <Managestafftable search={search} update={update} setUpdate={setUpdate}/>
                        </div>

                    </div>

                </div>
            </div>

            
        <AddTeamModal open={open} handleClose={handleClose} setUpdate={setUpdate}/>

        </div>
    )
}
